// extracted by mini-css-extract-plugin
export default {"headerBar":"IK-z","pointsSection":"JK-z","goToDashboard":"KK-z"};